import { TaggedGroups } from 'src/app/modules/mypurchase-form/rfs/tag-item-vendor.service';
import { DropDownOptions } from '../app-models';
import { VendorTagging } from '../app-models/MyPurchaseForm.model';
import { Item, TaggedGroup, Vendor } from './SaveMyPurchase.model';

export interface PEAssignmentListResponse {
  AssignmentList: { [key: string]: number[] };
  PurchaseExecutives: DropDownOptions[];
  dagId?: string;
}

export interface CheckRFSReadyRequest {
  MPDocumentNumber: string;
  actioner: string;
  dagId: string;
}

export const RFSReadyRole = Object.freeze({
  ASSIGNED_PE : 1
})

export interface CheckRFSReadyResponse {
  ready?: boolean;
  roleId: number;
  role: string;
}

export interface SaveTaggingRequest {
  MPDocumentNumber: string;
  itemList: Item[];
  vendorsList: Vendor[];
  taggedGroups: TaggedGroup[] | null;
}

export interface ReadyTaggingRequest {
  MPDocumentNumber: string;
  dagId: string;
  itemList: Item[];
  vendorsList: Vendor[];
  taggedGroups: TaggedGroup[];
}

export interface UnreadyTaggingRequest {
  MPDocumentNumber: string;
  dagId: string;
}
